import React from 'react';
import { Box } from 'rebass/styled-components';

import { layout } from '../constants/constants';
import { GlobalFooterContent, IconPack } from '../shared/models/app-data-model';
import GlobalFooterDesktop from './global-footer-desktop/global-footer-desktop';
import GlobalFooterMobile from './global-footer-mobile/global-footer-mobile';
import './global-footer.scss';

/**
 * Feature Toggle id for the SocialMediaButtons in the Footer
 * Should be retired sometime after PI 21.4.5
 */
export const FooterSocialMediaButtonsFeatureToggle = 'REBELSCRUM-729';

export type GlobalFooterProps = {
  title: string;
  content: GlobalFooterContent;
  copyrightSubtext?: string;
  iconPack: IconPack[];
};

const GlobalFooter: React.FC<GlobalFooterProps> = ({ content, copyrightSubtext, iconPack, title }: GlobalFooterProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="global-footer">
      {content?.footer_nav?.length > 0 && (
        <>
          <GlobalFooterDesktop content={content} />
          <GlobalFooterMobile iconPack={iconPack} content={content} />
        </>
      )}
      <Box className="footer-copyright" width={layout.pageWidth} px={layout.pagePaddingX} py={[5, 5, 5, 5, 10]} mx={'auto'}>
        {copyrightSubtext && <div>{copyrightSubtext}</div>}
        <div>
          Copyright &copy; {currentYear} {title}. All rights reserved.
        </div>
      </Box>
    </footer>
  );
};

export default GlobalFooter;
